import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a254ad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay-container" }
const _hoisted_2 = {
  key: 0,
  class: "clickable"
}
const _hoisted_3 = {
  key: 1,
  class: "controls-container clickable"
}
const _hoisted_4 = { id: "menus-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("IN APROPIERE")

import { ref } from 'vue';

import markerColors from '@/assets/raw/MarkerColors';

import TopMenu from './TopMenu.vue';
import ClosestMenu from './ClosestMenu.vue';
import Focus from './Focus.vue';
import ZoomIn from './ZoomIn.vue';
import ZoomOut from './ZoomOut.vue';
import RecyclingCenter from './RecyclingCenter.vue';
import Button from '@/components/ui/Button.vue';

interface IOverlayEmits {
	(e: 'zoomIn'): void;
	(e: 'zoomOut'): void;
	(e: 'focusMap'): void;
	(e: 'closest', id: number | 'all'): void;
}


export default /*#__PURE__*/_defineComponent({
  emits: ["zoomIn", "zoomOut", "focusMap", "closest"],
  setup(__props, { emit }: { emit: ({
	(e: 'zoomIn'): void;
	(e: 'zoomOut'): void;
	(e: 'focusMap'): void;
	(e: 'closest', id: number | 'all'): void;
}), expose: any, slots: any, attrs: any }) {



const menuActive = ref(false);

function toggleMenu() {
	menuActive.value = !menuActive.value;
}

// TODO: compute distances
const ClosestMenuProps = {
	pins: markerColors.map(c => ({ markerColor: c, distance: '. . . m' })),
	recyclingCenter: {
		markerColor: '#FFFFFF',
		distance: '. . . m',
	},
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopMenu, {
      id: "top-menu",
      class: "clickable"
    }),
    (menuActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ClosestMenu, {
            pins: ClosestMenuProps.pins,
            "recycling-center": ClosestMenuProps.recyclingCenter,
            onBack: toggleMenu,
            onClosest: _cache[0] || (_cache[0] = id => emit('closest', id))
          }, null, 8, ["pins", "recycling-center"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(RecyclingCenter, {
              id: "closest-button",
              class: "clickable",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('closest', 'all')))
            }),
            _createVNode(Button, {
              id: "closest-menu",
              onClick: toggleMenu
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(Focus, {
              class: "control-map clickable",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('focusMap')))
            }),
            _createVNode(ZoomIn, {
              class: "control-map clickable",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('zoomIn')))
            }),
            _createVNode(ZoomOut, {
              class: "control-map clickable",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('zoomOut')))
            })
          ])
        ]))
  ]))
}
}

})